export const settingsStyles = {
  settings_tab: {
    fontSize: '.9rem',
    fontWeight: 400,
    margin: 'auto 0',
  },
};
